import {
    apiRequest,
    PengaturanMenuCreate,
    PengaturanMenuParentList
} from "../../../../../services/adapters/kepegawaian/menuService"

class CreateRepository {
    
    fetchCreate = async (query) => {
        return await apiRequest("post", PengaturanMenuCreate, {
            body: query
        }, true)
    }

    fetchParentList = async (query, cancelToken) => {
        return await apiRequest("get", PengaturanMenuParentList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

}

export default CreateRepository